import React, { Component } from 'react';
import { withRouter,Redirect  } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Modal from 'react-responsive-modal';
import Radiobox from '../../../Comman/components/ModalRadioboxWithIndex';
import {InputText} from 'primereact/inputtext';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { TabView, TabPanel } from 'primereact/tabview';
import SimpleReactValidator from 'simple-react-validator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {baseUrl} from '../../../Comman/apiEndPoints';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import InputWithExtra from '../../../Comman/components/InputWithExtra';
import Select from 'react-select';

var deleteList = [], disableList = [];
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var svValidator;
var engValidator;
var engUserInfoValidator;
var svUserInfoValidator;
class HeartRunnerListComponent extends Component {
    constructor(props) {
        super(props);
        this.settingValidator=new SimpleReactValidator();
        this.toggleAll = this.toggleAll.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);
        this.disableSelected = this.disableSelected.bind(this)
        this.state = {
            allDeleteSelected: false,
            deleteSelection: [],
            allDisableSelected: false,
            allEnableSelected: false,
            disableSelection: [],
            enableSelection: [],
            open: false,
            cats: [{name:"", age:""}],
            errorDisable:'',
            openModal:false,
            RegionId:'',
            heartRunnerDetails:{
                Username:'',
                FirstName:'',
                LastName:'',
                PhoneNumber:'',
                EmailId:'',
                Password:'',
                ConfirmPassword:'',
                isProfile:false,
                profilePic : '',
                nameInitials : '',
                AliasName:'',
                WorkingPlace : '',
                Proffession  : '',
                CPREducation : '',
                CountryCode : '',
                RegionId:null,
                PermissionId:[],
                UserType:'',
                Permissions:[]
            },
            settingInfo:{
                IsCoordinateBase:false,
            },
            primaryOptions: ['No','Yes'] ,
        };
        this.baseState=this.state
    }
    componentWillMount(){
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.',
            max : 'The :attribute may not be greater than :max:type.'
          });
          SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.',
            max : ':attribute kanske inte är större än :max tecken.'
          });
          engValidator = new SimpleReactValidator({
            locale : 'en', 
            autoForceUpdate: this
          });
          svValidator = new SimpleReactValidator({
            locale : 'sv', 
            autoForceUpdate: this
         });
        this.validator = engValidator;
        engUserInfoValidator = new SimpleReactValidator({
            locale : 'en',
            validators:{
                phoneValidation: {
                    message: 'The phone must be a valid phone number.',
                    rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val,/^(?=.*[0-9])[ ()0-9]+$/) && params.indexOf(val) === -1
                    }
                },
                allowSwedish: {  // name the rule
                    message: 'The :attribute may only contains letters.',
                    rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val,/^[a-zA-Z åäöÅÄÖ!@#\$%\^\&*\)\(+=._-]+$/g) && params.indexOf(val) === -1
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                  },
            }
        });
        svUserInfoValidator = new SimpleReactValidator({
            locale : 'sv',
            validators:{
                phoneValidation: {
                    message: 'Telefonnummer måste vara ett giltigt telefonnummer.',
                    rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val,/^(?=.*[0-9])[ ()0-9]+$/) && params.indexOf(val) === -1
                    }
                },
                allowSwedish: {  // name the rule
                    message: ':attribute får endast innehålla bokstäver.',
                    rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val,/^[a-zA-Z åäöÅÄÖ!@#\$%\^\&*\)\(+=._-]+$/g) && params.indexOf(val) === -1
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                  },
            }
        });
        this.userInfoValidator = engUserInfoValidator;
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next",nextProps)
        if (nextProps.heartRunnerList.messageLabel !== this.props.heartRunnerList.messageLabel) {
            
            if(nextProps.heartRunnerList.statusCode==200){
                this.notify(nextProps.heartRunnerList.messageLabel)
                this.closeModal();
                this.setState(this.baseState)  
                this.validator.hideMessages();
                this.props.getList();
            }
            if(nextProps.heartRunnerList.statusCode==201){
                this.errornotify(nextProps.heartRunnerList.messageLabel);
                this.props.getList();
            }
        }
         
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
          this.userInfoValidator = engUserInfoValidator;
        }
        else{
          this.validator = svValidator;
          this.userInfoValidator = svUserInfoValidator;
        }
      }
    // closeModal =()=> {
    //     this.setState({ open: false })
    // }
    notify = (message) => {
        swal({ text : message, icon : 'success' })
     
        // this.toastId =toast.success(message, {
        //   position: toast.POSITION.TOP_CENTER
        // });
    }
   
    errornotify = (message) => {
        // toast.error(message + "!", {
        //     position: toast.POSITION.TOP_CENTER
        // });
        swal({ text : message, icon : 'error' })

    };
    onDeleteClick(e) {
        const item = e;
        this.toggleSelection(item);
    }

    onDisableClick(e) {
        const item = e;
        this.toggleDisableSelection(item);
    }
    onEnableClick(e) {
        const item = e;
        this.toggleEnableSelection(item);
    }

    toggleSelection(item) {
        let deleteSelection;

        if (this.isSelected(item)) {
            deleteSelection = this.state.deleteSelection.filter(x => x !== item);
        } else {
            deleteSelection = [...this.state.deleteSelection, item];
        }

        const allDeleteSelected = deleteSelection.length === deleteList.length;
        this.setState({ allDeleteSelected, deleteSelection });
    }

    toggleDisableSelection(item) {
        let disableSelection;

        if (this.isDisableSelected(item)) {
            disableSelection = this.state.disableSelection.filter(x => x !== item);
        } else {
            disableSelection = [...this.state.disableSelection, item];
        }

        const allDisableSelected = disableSelection.length === disableList.length;
        this.setState({ allDisableSelected, disableSelection });
    }
    toggleEnableSelection(item) {
        let enableSelection;

        if (this.isEnableSelected(item)) {
            enableSelection = this.state.enableSelection.filter(x => x !== item);
        } else {
            enableSelection = [...this.state.enableSelection, item];
        }

        const allEnableSelected = enableSelection.length === disableList.length;
        this.setState({ allEnableSelected, enableSelection });
    }

    toggleAll(allDeleteSelected) {
        const deleteSelection = allDeleteSelected ? deleteList : [];
        this.setState({ allDeleteSelected, deleteSelection });
    }

    toggleDisableAll(allDisableSelected) {
        const disableSelection = allDisableSelected ? disableList : [];
        this.setState({ allDisableSelected, disableSelection });
    }

    isSelected(item) {
        return (this.state.deleteSelection.includes(item));
    }

    isDisableSelected= (item)=> {
        return (this.state.disableSelection.includes(item));
    }
    isEnableSelected= (item)=> {
        return (this.state.enableSelection.includes(item));
    }

    deleteSelected() {
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to delete')}`,
            message: `${t('First_Responder.Are you sure to delete this?')}`,
            buttons: [
              {
                label: `${t('First_Responder.Yes')}`,
                onClick: () => {
                    if(this.state.deleteSelection.length > 0){
                        // let request = {
                        //     UserId : this.state.deleteSelection[0].UserId
                        // }
                        let requestPayload = [];
                        this.state.deleteSelection.forEach(item =>{
                            if(item.UserId){
                                requestPayload.push({UserId : item.UserId})
                            }
                        })
                        this.props.onDelete(requestPayload,this.state.deleteSelection[0].RegionId);
                        this.setState({
                            allDeleteSelected: false,
                            deleteSelection: [],
                            errorDisable:''
                        });            
                        
                    }
                    else{
                        alert(`${t('First_Responder.Please select atleast one device')}`)
                        this.setState({errorDisable:`${t('First_Responder.Please select atleast one device')}`})
                    }
                  
                }
              },
              {
                label: `${t('First_Responder.No')}`,
                onClick: () => {
                }
              }
            ]
          });
        
    }
    logoutUser = (rowData) => {
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to Logout')}`,
            message: `${t('First_Responder.Are you sure to logout this user')}`,
            buttons: [
              {
                label: `${t('First_Responder.Yes')}`,
                onClick: () => {
                    let requestPayload = {
                        UserId : rowData.UserId
                    }
                        this.props.onLogout(requestPayload,rowData.RegionId);
                    }
              },
              {
                label: `${t('First_Responder.No')}`,
                onClick: () => {
                }
              }
            ]
          });
    }
    disableSelected() {
        if(this.state.disableSelection.length > 0){
            this.props.onDisable(this.state.disableSelection);
            this.setState({
                allDisableSelected: false,
                disableSelection: [],
                errorDisable:''
            });
        }
        else{
            this.setState({errorDisable:'Please select atleast one device'})
        }
    }

    enableSelected=()=> {
        
        if(this.state.enableSelection.length > 0){
            this.props.onEnable(this.state.enableSelection);
            this.setState({
                allEnableSelected: false,
                enableSelection: [],
                errorDisable:''
            });
        }
        else{
            this.setState({errorDisable:'Please select atleast one device'})
        }
    }

    openPinManagement=(rowData)=> {
        let url='/superadmin/addAdmin/'+rowData.UserId
        this.props.history.push(url)
    }

    disableCheckbox=(rowData)=>{
        const { t } = this.props;
        let IsEnabled = rowData.IsEnabled;
       
        return(
            <div>
           {/*<span className="delbtn" onClick={() => { this.openModal(rowData) }} title="Edit"><i className="fa fa-pencil" aria-hidden="true"></i></span>*/}

                <input type="checkbox" className="delbtn" title={t('First_Responder.Delete')} onChange={(e) => { this.onDeleteClick(rowData) }} checked={this.isSelected(rowData)} />
                {/* {!IsEnabled?
                    <input 
                        type="checkbox" title="Enable"                     
                        onChange={(e) => { this.onEnableClick(rowData) }} 
                        checked={this.isEnableSelected(rowData)} 
                        className="delbtn"
                    />
                    :
                    <input 
                        type="checkbox" title="Enable" 
                        checked={"checked"}
                         disabled   
                         className="delbtn"                                        
                    />
                } */}
                {/* {IsEnabled?
                    <input 
                        type="checkbox" 
                        title="Disable" 
                        onChange={(e) => { this.onDisableClick(rowData) }} 
                        checked={this.isDisableSelected(rowData)} 
                    />
                    :
                    <input 
                        type="checkbox" title="Disable" 
                        checked={"checked"}
                         disabled                                           
                    />
                } */}
                <span  className="enable-cursor delbtn" onClick={() => { this.logoutUser(rowData) }} tooltip="Logout" title={t('Menu.Logout')}>
                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                </span>
              
            </div>        

            )
    }
    deleteCheckbox=(rowData)=>{
        return(<input type="checkbox" title="Delete" onChange={(e) => { this.onDeleteClick(rowData) }} checked={this.isSelected(rowData)} />)
    }

    addCat = (e) => {
        this.setState((prevState) => ({
            cats: [...prevState.cats, {name:"", age:""}],
        }));
    }
    rowClassName(rowData){
       
        let IsEnabled = rowData.IsEnabled;

        return {'p-highlight' : (IsEnabled ==false)};
        
    }
    redirectTo=(page)=>{
        //let url=page+this.props.match.params.id;
        this.props.history.push(page)
    }

    actionCheckbox=(rowData)=>{
        return( <div className="pins-str" id="pins-str">
                 
                 <span className="delbtn" onClick={() => { this.openModal(rowData) }} title="Edit"><i className="fa fa-pencil" aria-hidden="true"></i></span>
                      
             </div> 
        )
     }
    resetDeviceKey=(rowData)=>{
        this.props.resetDeviceKey({UserId:rowData.UserId,OrganizationID:this.props.match.params.id})
    }
    openModal=(rowData)=> {
        
        this.setState({ openModal: true })
        this.setState( prevState => ({ heartRunnerDetails : 
        {...prevState.heartRunnerDetails, 
            Username:rowData.Username,
            FirstName:rowData.FirstName,
            LastName:rowData.LastName,
            AliasName:rowData.Alias,
            PhoneNumber:rowData.PhoneNumber,
            EmailId:rowData.EmailId,
            UserId:rowData.UserId,
            Image:'',
            CertificateID:rowData.CertificateId,
            isProfile : rowData.Image ? true : false,
            WorkingPlace : rowData.WorkingPlace,
            Proffession  : rowData.Proffession,
            CPREducation : rowData.CPREducation,
            CountryCode : rowData.CountryCode,
            RegionId:rowData.RegionId,
            PermissionId:rowData.rolePermission,
            UserType:rowData.UserType
        }
        }),  )
              let permissionListData=this.props.heartRunnerList.permissionList.map(({ ID, Permission,Category }) => {
  return {
   ID, Permission,Category,
  }
})
          let RefPermission=permissionListData.filter((i)=>i.Category.toLowerCase()==rowData.UserType.toLowerCase())
         
          this.setState( prevState => ({ heartRunnerDetails : 
                {...prevState.heartRunnerDetails, Permissions: RefPermission}
          }))
        this.setState( prevState => ({ settingInfo : 
            {...prevState.settingInfo, 
                IsCoordinateBase: rowData.IsCoordinateBase,
                DistanceUnit: rowData.DistanceUnit,
                Distance:rowData.Distance

            }
        }))
  

        sleep(500).then(() => {
            if(rowData.Image){
                // document.getElementById("profile-img-src").src = baseUrl + rowData.Image;
                this.setState(prevState => ({ heartRunnerDetails :
                    {...prevState.heartRunnerDetails,
                        profilePic : baseUrl + rowData.Image
                    }
                }))
            }
            else{
                var initials = rowData.FirstName.charAt(0).toUpperCase() + rowData.LastName.charAt(0).toUpperCase();
                // document.getElementById("name-initials").innerHTML =  nameInitials;
                this.setState(prevState => ({ heartRunnerDetails :
                    {...prevState.heartRunnerDetails,
                        nameInitials : initials
                    }
                }))
            }
        })
       
    }
    closeModal =()=> {
        this.setState({ openModal: false })
        this.setState(this.baseState)
    }
    updateHeartRunnerDetails = ()=>{
        const { t } = this.props;
         if(this.state.heartRunnerDetails.PermissionId.length ==0 && this.state.heartRunnerDetails.UserType !='User' ){
            this.errornotify('Please select at least 1 permission');
            return
        }
        if(this.userInfoValidator.allValid()){ 
         
            let heartRunnerInfoData = this.state.heartRunnerDetails;
            if(heartRunnerInfoData.PhoneNumber.charAt(0) == '0'){
                heartRunnerInfoData.PhoneNumber = heartRunnerInfoData.PhoneNumber.split('0')[1];
            }
              if(heartRunnerInfoData.RegionId==null || heartRunnerInfoData.RegionId==0 || heartRunnerInfoData.RegionId=='0')
          {
            heartRunnerInfoData.RegionId= this.props.heartRunnerList.regionList[0].ID;
          }
             if(heartRunnerInfoData.UserType==null || heartRunnerInfoData.UserType==0 || heartRunnerInfoData.UserType=='')
          {
            heartRunnerInfoData.UserType= 'Admin';
          }
          
            let requestPayload = {
                UserId : heartRunnerInfoData.UserId,
                Phone : heartRunnerInfoData.PhoneNumber,
                Password : null,
                CertificateId : heartRunnerInfoData.CertificateID,
                FirstName:heartRunnerInfoData.FirstName, 
                LastName:heartRunnerInfoData.LastName, 
                Alias:heartRunnerInfoData.AliasName,
                WorkingPlace  : heartRunnerInfoData.WorkingPlace,
                Proffession : heartRunnerInfoData.Proffession,
                CPREducation : heartRunnerInfoData.CPREducation,
                CountryCode : heartRunnerInfoData.CountryCode,
                RegionId:heartRunnerInfoData.RegionId,
                PermissionId:heartRunnerInfoData.PermissionId.map(x=>x.ID),
            UserType:heartRunnerInfoData.UserType
            }
            this.closeModal()
            this.notify(`${t("First_Responder.Please Sync with dispatcher")}`);
            this.props.updateHeartRunnerDetails(requestPayload);
        }
        else {
            this.userInfoValidator.showMessages();
            this.forceUpdate();
        }
    }
     successnotify = (message) => {
      // toast.success(message+"!", {
      //   position: toast.POSITION.TOP_CENTER
      // });
      swal({text : message, icon : 'success'})
    
    }
    onPrimaryChange=(changeEvent)=> {
    
        let value = changeEvent.target.value;
        let name = changeEvent.target.name;
        
       this.setState( prevState => ({ heartRunnerDetails : 
         {...prevState.heartRunnerDetails, IsPrimary: value}
       }))
     }
    handleInput=(e)=>{
       
        let value = e.target.value;
        let name = e.target.name;
        this.setState( prevState => ({ heartRunnerDetails : 
          {...prevState.heartRunnerDetails, [name]: value}
         }),  )
    }

    deleteImage = () =>{
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to delete')}`,
            message: `${t('First_Responder.Are you sure to delete this?')}`,
            buttons: [
              {
                label: `${t('First_Responder.Yes')}`,
                onClick: () => {
                    
        let heartRunnerInfoData = this.state.heartRunnerDetails;
        let requestPayload = {
            UserId : heartRunnerInfoData.UserId
        }
        this.props.removeProfilePicture(requestPayload,heartRunnerInfoData.RegionId);
    }
              },
              {
                label: `${t('First_Responder.No')}`,
                onClick: () => {
                }
              }
            ]
          }); 
      }

    updatePassword=()=>{
        const { t } = this.props;
        if (this.validator.allValid()) {
            let changePasswordData={
                'Password':this.state.heartRunnerDetails.Password,
                'UserId':this.state.heartRunnerDetails.UserId,
                'Phone' : null,
                'CertificateId' : null,
                'UserType':this.state.heartRunnerDetails.UserType
            }
            this.closeModal()
            let successMessage=t('Login.Password Updated')
            this.successnotify(successMessage)
            this.props.updatePassword(changePasswordData,this.state.heartRunnerDetails.RegionId)
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    crudcheckbox=(rowData)=>{
        const { t } = this.props;
        return( <div className="pins-str" id="pins-str"> 
                 <span className="delbtn" onClick={() => { this.openModal(rowData) }} title={t('First_Responder.Edit')}><i className="fa fa-pencil" aria-hidden="true"></i></span>
                 {/* <span className="delbtn" onClick={() => { this.resetDeviceKey(rowData) }} title="Reset Device Key"><i className="fas fa-redo-alt"></i></span> */}
         </div> 
        )
     }
     setStatus = (rowData) => {
        if(rowData.UserLogout == "False"){
            return (<span className="box" style={{background: '#06c706'}}></span>) // online
        }
        else if(rowData.UserLogout == "True"){
            return (<span className="box" style={{background: '#e92828'}}></span>) //offline
        }
        else {
            return (<span className="box" style={{background: '#000000'}}></span>) // no login yet
        }
     }
     getPhoneNumber = (data) => {
         if(data){
             return '+' + data.CountryCode + data.PhoneNumber;
         }
     }
     IsCoordinateBaseCheck = () =>{
        let IsCoordinateBase=!this.state.settingInfo.IsCoordinateBase;         
        
        this.setState( prevState => ({ settingInfo : 
                {...prevState.settingInfo, 
                    IsCoordinateBase: IsCoordinateBase,
                    DistanceUnit: '',
                    Distance:''
    
                }
        }))
        
        
    }
    handleSettingInput=(e)=>{
        let value = e.target.value;
        let name = e.target.name;
        this.setState( prevState => ({ settingInfo : 
          {...prevState.settingInfo, [name]: value}
         }),  )
    }
    updateAlarmSettings=()=>{
        const { t } = this.props;
        // if (!this.settingValidator.allValid()) {
            
        //     this.settingValidator.showMessages();
        //     this.forceUpdate();
        // }
        if(this.state.settingInfo.Distance < 200){
            this.errornotify(`${t('First_Responder.Please enter 200 meter distance and above')}`);
        }
        
        else{
            let profileInfoData = this.state.settingInfo;
            let heartRunnerInfoData = this.state.heartRunnerDetails;
            profileInfoData.UserId= heartRunnerInfoData.UserId;
            let requestPayload = {
                UserId : heartRunnerInfoData.UserId,
                Distance : profileInfoData.Distance,
                UserType:heartRunnerInfoData.UserType
            }
            this.closeModal();
             let successMessage=t('Login.Alarm Details Updated')
            this.successnotify(successMessage)
            this.props.updateAlarmSettings(requestPayload,this.state.heartRunnerDetails.RegionId)
            this.settingValidator.hideMessages();
             
        }
    }      
      changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    handlePermissionChange = (event) => {
    

       this.setState( prevState => ({ heartRunnerDetails : 
                {...prevState.heartRunnerDetails, PermissionId: event}
          }))
  }
  permissionType(e){
let value = e.target.value;
       let name = e.target.name;
     
    

       this.setState( prevState => ({ heartRunnerDetails : 
                {...prevState.heartRunnerDetails, [name]: value}
          }))
             let permissionListData=this.props.heartRunnerList.permissionList.map(({ ID, Permission,Category }) => {
  return {
   ID, Permission,Category,
  }
})
         let RefPermission=permissionListData.filter((i)=>i.Category.toLowerCase()==value.toLowerCase())
           this.setState( prevState => ({ heartRunnerDetails : 
                {...prevState.heartRunnerDetails, Permissions: RefPermission,PermissionId:RefPermission}
          }))
      
      }
    render() {
        const { t } = this.props;
        let  countryListOption; 
        let countryListVal = this.props.heartRunnerList.countryList;
         let  regionListOption; 
      let regionList=this.props.heartRunnerList.regionList;
        if(countryListVal){
          countryListOption = countryListVal.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.CountryCode} key={item.CountryCode}>{item.CountryName} - {item.CountryCode}</option>
            );
        }
        let rolesType
        rolesType=  <span>
                <option value={'Superadmin'} key={'Superadmin'}>Superadmin</option>
                                                    <option value={'Admin'} key={'Admin'}>Admin</option>
                                                    <option value={'User'} key={'User'}>User</option>
              </span>
if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        let orgVal = ['Select','Miles','Km','Meter'];
        let optionDistance;
        optionDistance=orgVal.map((organizationVal,index) =>

               
            <option value={organizationVal} key={index}>{organizationVal}</option>
        );
        let permissionListData=this.props.heartRunnerList.permissionList.map(({ ID, Permission,Category }) => {
  return {
   ID, Permission,Category,
  }
})
        var header = <div className="search-name">
        <i className="fa fa-search" style={{margin:'4px 4px 0 0'}}></i>
        <InputText type="text" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder={t('First_Responder.Search')} size="50"/>
    </div>;
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Menu.First Responder')}</h2>
                </div>
                {/* <ToastContainer /> */}
                <div className=" forms-panel w3-last-form">
                        <div className="forms add-device">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                     <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div>
                                   
                                    <div className="w3l_search">
                                        {header}
                                    </div>
                                    <div className="devicestable">
                                    
                                   
                                      <br />                  
                                    

                                <DataTable 
                                    className="table" 
                                    value={this.props.heartRunnerList.heartRunnerList} 
                                    loading={this.props.heartRunnerList.isLoading}  
                                    paginator={true} rows={10}
                                    globalFilter={this.state.globalFilter}
                                    
                                    // rowClassName={this.rowClassName}
                                    
                            >
                           
                            <Column field="UserId" header="" className="noDisplay" sortable={true} />
                            <Column field="DeviceId" header="" className="noDisplay" sortable={true} />
                            <Column header="Status" body={this.setStatus}  />
                            <Column field="FirstName" header={t('First_Responder.First Name')} sortable={true}  />
                            <Column field="LastName" header={t('First_Responder.Last Name')} sortable={true} />
                            <Column field="RegionName" header={'Region'} sortable={true} />
                            <Column sortable={true} field="Alias" header={t('First_Responder.Alias Name')} />
                            {/* <Column field="Username" header="User Name" sortable={true} /> */}
                            <Column body={this.getPhoneNumber} header={t('First_Responder.Phone Number')} className="wordBreakLine" sortable={true} />
                            <Column field="EmailId" header={t('First_Responder.Email')} className="wordBreakLine" sortable={true} />                           
                            {/* <Column field="CertificateId" header={t('First_Responder.Certification ID')} className="wordBreakLine" sortable={true} />                            */}
                            
                            <Column  header={t('First_Responder.Edit')} body={this.crudcheckbox}
                            />
                            
                            <Column header={
                                <div>
                               
                                <span className="enable-cursor"  tooltip="Delete">
                                </span>
                                     <span className="enable-cursor delbtn" onClick={this.deleteSelected} tooltip="Delete" title={t('First_Responder.Delete')}><i className="fa fa-lg fa-trash" aria-hidden="true"></i>
                                                 </span>      
                                    <span  className="enable-cursor delbtn">
                                       {t('Menu.Logout')}
                                    </span>
                                    {/* <span  className="enable-cursor" onClick={this.disableSelected} tooltip="Disable"><i className="fa fa-ban" aria-hidden="true"></i>
                                    </span> */}
                                        
                                        
                                </div>        
                            } body={this.disableCheckbox}
                            />
                        </DataTable>
                                </div>
                                </div>
                            </div>
                        </div>    
                </div> 
                <Modal open={this.state.openModal}  onClose={this.closeModal} center> 
                <div className="modal1 alarmsetmodal">
                    <div className="progressbar-heading grids-heading">
                             <h2>{t('First_Responder.First Responder Details')}</h2>
                    </div>
                    
                    <TabView activeIndex={this.state.activeIndex} className="tabclass tab-respon" onTabChange={(e) => this.setState({activeIndex: e.index})}>
                        <TabPanel header={t('First_Responder.First Responder Info')}> 
                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="form-three widget-shadow">
                                        <div className=" panel-body-inputin"> 
                                        <div className="profile-dp">
                                            { this.state.heartRunnerDetails.isProfile ? 
                                              <div> <img className="profile-img" id="profile-img-src" src={this.state.heartRunnerDetails.profilePic} alt="" />  <button type="button" className="btn btn-primary del-img" onClick={this.deleteImage}>{t('Carousel Setting.Delete Image')}</button>
                                              </div>  :
                                                  <div id="name-initials">{this.state.heartRunnerDetails.nameInitials}</div>
                                            }
                                        </div>
                                            <form className="form-horizontal modalForm" >
                                                <div className="form-group">
                                                    
                                                    <label className="col-sm-3 control-label">{t('First_Responder.WorkingPlace')}</label>
                                                    <div className="col-sm-9">
                                                        <InputWithExtra 
                                                            type="text" 
                                                            id="WorkingPlace"
                                                            name= {'WorkingPlace'}
                                                            value={this.state.heartRunnerDetails.WorkingPlace} 
                                                            className="form-control1 FR-edit-details" 
                                                            onChange = {this.handleInput} 
                                                             // readOnly
                                                        />
                                                        
                                                    </div>
                                                    
                                                </div>
                                                <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Proffession')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="text" 
                                                    id="Proffession"
                                                    name= {'Proffession'}
                                                    value={this.state.heartRunnerDetails.Proffession} 
                                                    className="form-control1  FR-edit-details" 
                                                    onChange = {this.handleInput} 
                                                     // readOnly
                                                />
                                                
                                            </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.First Name')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="text" 
                                                    id="FirstName"
                                                    name= {'FirstName'}
                                                    value={this.state.heartRunnerDetails.FirstName} 
                                                    className="form-control1 FR-edit-details" 
                                                    onChange = {this.handleInput} 
                                                     // readOnly
                                                />
                                                {this.userInfoValidator.message(`${t('First_Responder.First Name')}`, this.state.heartRunnerDetails.FirstName, 'required|allowSwedish|min:2')}
                                            </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Last Name')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="text" 
                                                    name= {'LastName'}
                                                    value={this.state.heartRunnerDetails.LastName} 
                                                    className="form-control1 FR-edit-details" 
                                                    onChange = {this.handleInput} 
                                                    id="LastName"
                                                     // readOnly
                                                />
                                                {this.userInfoValidator.message(`${t('First_Responder.Last Name')}`, this.state.heartRunnerDetails.LastName, 'required|allowSwedish|min:2')}
                                            </div>
                                            
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('First_Responder.CPREducation')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="text" 
                                                    id="CPREducation"
                                                    name= {'CPREducation'}
                                                    value={this.state.heartRunnerDetails.CPREducation} 
                                                    className="form-control1 FR-edit-details" 
                                                    onChange = {this.handleInput} 
                                                     // readOnly
                                                />
                                                
                                            </div>
                                        </div>
                                        <div className="form-group">
                                                    
                                                    <label className="col-sm-3 control-label">{t('First_Responder.Alias Name')}</label>
                                                    <div className="col-sm-9">
                                                        <InputWithExtra 
                                                            type="text" 
                                                            name= {'AliasName'}
                                                            value={this.state.heartRunnerDetails.AliasName} 
                                                            className="form-control1 FR-edit-details" 
                                                            onChange = {this.handleInput} 
                                                            id="AliasName"
                                                            // readOnly
                                                        />
                                                        
                                                    </div>
                                                    
                                                </div>
                                        {/* <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">Username</label>
                                            <div className="col-sm-9">
                                                <input 
                                                    type="text" 
                                                    name= {'Username'}
                                                    value={this.state.heartRunnerDetails.Username} 
                                                    className="form-control1" 
                                                    id="Username"
                                                    readOnly
                                                />
                                                
                                            </div>
                                            
                                        </div> */}
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Email')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="text" 
                                                    name= {'EmailId'}
                                                    value={this.state.heartRunnerDetails.EmailId} 
                                                    className="form-control1 FR-edit-details"
                                                    id="EmailId"
                                                    onChange = {this.handleInput}
                                                    readOnly
                                                />
                                                {this.userInfoValidator.message(`${t('First_Responder.Email ID')}`, this.state.heartRunnerDetails.EmailId, 'required|email')}
                                            </div>
                                            
                                        </div>
                                          <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('Regions')}</label>
                                            <div className="col-sm-9">
                                                <div className="input-group">   
                                                    <span className="input-group-addon">
                                                        <i className="" aria-hidden="true"></i>
                                                    </span>
                                                    <select id="regionData"  className="form-control1 FR-edit-details"
                                                        onChange={this.handleInput} 
                                                        value = {this.state.heartRunnerDetails.RegionId}
                                                        placeholder="Select" 
                                                        ref="regionData"
                                                        name= {'RegionId'}
                                                    >
                                                      
                                                        {regionListOption}
                                                    </select>
                                                </div>
                                            </div>
                                            
                                        </div>
                                         <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('Roles')}</label>
                                            <div className="col-sm-9">
                                                <div className="input-group">   
                                                    <span className="input-group-addon">
                                                        <i className="" aria-hidden="true"></i>
                                                    </span>
                                                 <select id="UserType" className="form-control1"
                                                    onChange={e => { this.permissionType(e)}}
                                                    value={this.state.heartRunnerDetails.UserType}
                                                    placeholder="Select"
                                                    ref="UserType"
                                                    name={'UserType'}
                                                >
                                                    {rolesType}
                                                    {/* <option value={'Superadmin'} key={'Superadmin'}>Superadmin</option>
                                                    <option value={'Admin'} key={'Admin'}>Admin</option>
                                                    <option value={'User'} key={'User'}>User</option> */}
                                                </select>
                                                </div>
                                            </div>
                                            
                                        </div>
                                         <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('Permissionss')}</label>
                                            <div className="col-sm-9">
                                                <div className="input-group">   
                                                    <span className="input-group-addon">
                                                        <i className="" aria-hidden="true"></i>
                                                    </span>
                                                   <Select id="Permission" 
        className="dropdown"
        placeholder="Select Option"
        value={this.state.heartRunnerDetails.PermissionId} // set selected values
        options={this.state.heartRunnerDetails.Permissions} // set list of the data
        onChange={this.handlePermissionChange} // assign onChange function
          getOptionLabel  = {(option)=>option.Permission}
        getOptionValue = {(option)=>option.ID}
        isMulti
        isClearable
      />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Phone Code')}</label>
                                            <div className="col-sm-9">
                                                <div className="input-group">   
                                                    <span className="input-group-addon">
                                                        <i className="" aria-hidden="true"></i>
                                                    </span>
                                                    <select id="countryData"  className="form-control1 FR-edit-details"
                                                        onChange={this.handleInput} 
                                                        value = {this.state.heartRunnerDetails.CountryCode}
                                                        placeholder="Select" 
                                                        ref="countrycodeData"
                                                        name= {'CountryCode'}
                                                    >
                                                        {countryListOption}
                                                    </select>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Phone Number')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="text" 
                                                    name= {'PhoneNumber'}
                                                    value={this.state.heartRunnerDetails.PhoneNumber} 
                                                    className="form-control1 FR-edit-details" 
                                                    onChange = {this.handleInput}                                                     
                                                    id="PhoneNumber"
                                                />
                                                {this.userInfoValidator.message(`${t('First_Responder.Phone Number')}`, this.state.heartRunnerDetails.PhoneNumber, 'required|phoneValidation|min:8|max:15')}
                                            </div>
                                            
                                        </div>
                                        {/* <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Certification ID')}</label>
                                            <div className="col-sm-9">
                                                <input 
                                                    type="text" 
                                                    name= {'CertificateID'}
                                                    value={this.state.heartRunnerDetails.CertificateID} 
                                                    className="form-control1" 
                                                    onChange = {this.handleInput}                                                     
                                                    id="CertificateID"
                                                />
                                                
                                            </div>
                                            
                                        </div> */}
                                        
                                        
                                        
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={() => { this.updateHeartRunnerDetails() }}
                                                >
                                                {t('First_Responder.Save')}
                                            </button>
                                            {
                                                this.props.isLoading?
                                                <i className="fa fa-spinner fa-spin pl-md-2 "></i>:''
                                            }
                                            </p>
                                            </div>
                                        </div>
                                
                                
                                </form>
                                        </div>
                                    </div>
                                </div>      
                        
                            </div>                           
                       
                        </TabPanel>
                        <TabPanel header={t('First_Responder.Change Password')}>     
                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="form-three widget-shadow">
                                        <div className=" panel-body-inputin">
                                            <form className="form-horizontal" >
                                
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Password')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="password"
                                                    name="Password"
                                                    value={this.state.heartRunnerDetails.Password} 
                                                    className="form-control1 FR-edit-details" 
                                                    onChange = {this.handleInput} 
                                                    autocomplete="new-password"
                                                />
                                               {this.validator.message(`${t('First_Responder.Password')}`, this.state.heartRunnerDetails.Password, 'required|min:6')} 
                                            </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('First_Responder.Confirm Password')}</label>
                                            <div className="col-sm-9">
                                                <InputWithExtra 
                                                    type="password" 
                                                    name= {'ConfirmPassword'}
                                                    value={this.state.heartRunnerDetails.ConfirmPassword} 
                                                    className="form-control1 FR-edit-details" 
                                                    onChange = {this.handleInput} 
                                                    //onBlur={() => this.validator.showMessageFor('ConfirmPassword')}
                                                    autocomplete="new-password"
                                                />
                                                {this.validator.message(`${t('First_Responder.Confirm Password')}`, 
                                                    this.state.heartRunnerDetails.ConfirmPassword, 
                                                    `required|in:${this.state.heartRunnerDetails.Password}`, 
                                                    {messages: {in: `${t('First_Responder.Passwords need to match')}`}})
                                                }
                                            </div>
                                            
                                        </div>
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={() => { this.updatePassword() }}
                                                >
                                                 {t('First_Responder.Save')}
                                            </button>
                                           
                                            </p>
                                            </div>
                                        </div>
                                        
                                
                                
                                </form>
                                        </div>
                                    </div>
                                </div>      
                        
                            </div>                           
                       
                        </TabPanel>
                        <TabPanel header={t('First_Responder.Distance Setting')}>     
                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="form-three widget-shadow">
                                        <div className=" panel-body-inputin">
                                            <form className="form-horizontal" >
                                
                                        {/* <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">Recieve Alarms </label>
                                            <div className="col-sm-9 control-label">
                                                <div className="input-group">  
                                                    <input
                                                        className="form-checkbox"
                                                        name="IsCoordinateBase"
                                                        id="IsCoordinateBase"

                                                        defaultChecked={this.state.settingInfo.IsCoordinateBase}
                                                        type="checkbox" 
                                                        onChange={this.IsCoordinateBaseCheck}
                                                    />
                                                </div>     
                                            </div>
                                            
                                        </div> */}
                                        <div className="form-group">
                                                    
                                            <label className="col-md-12 control-label text-center">
                                                {t('First_Responder.Distance from the alarm coordinate')}
                                            </label>
                                        <div className="row text-center">
                                            <div className="col-md-4"></div>    
                                            <div className="col-md-4 control-label">
                                               
                                                
                                                <InputWithExtra type="text" className="form-control1 FR-edit-details" 
                                                            name="Distance"
                                                            placeholder={t('First_Responder.Distance in meter')}
                                                            value={this.state.settingInfo.Distance} 
                                                            
                                                            onChange={this.handleSettingInput}
                                                        />
                                            </div>
                                        </div>    

                                            {/* <div className="col-md-4 control-label">
                                                <select id="distanceunits"  
                                                        className="form-control1" 
                                                        onChange={this.handleSettingInput} 
                                                        value = {this.state.settingInfo.DistanceUnit}
                                                        placeholder="Select" 
                                                        ref="DistanceUnit"
                                                        name='DistanceUnit'
                                                        
                                                >
                                                {optionDistance} 
                                                </select>
                                                
                                                   
                                        
                                                    
                                            </div> */}
                                            
                                        </div>
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={() => { this.updateAlarmSettings() }}
                                                >
                                              {t('First_Responder.Save')}
                                            </button>
                                           
                                            </p>
                                            </div>
                                        </div>
                                        
                                
                                
                                        </form>
                                        </div>
                                    </div>
                                </div>      
                        
                            </div>                           
                       
                        </TabPanel>
                
                </TabView>   
                </div>
            </Modal>          
                    
                             
                        
                   
            </div>
        )
    }
}

export default withNamespaces()(withRouter(HeartRunnerListComponent));

